import {useEffect, useState} from "react";
import {getCommonCodeGroup} from "../../../../api/api";

export default (props) => {
	useEffect(() => {

	}, [])

	const handleChange = (e) => {
		const updateRowData = {
			...props.data, value: e.target.value
		}
		props.onEventChange(props.rowIndex, updateRowData);
	}

	return (
		<div className={"d-flex flex-row"}>
			{props.data.selectValues.map((item, i) => {
				const value = props.data.value === null ? '0' : props.data.value;
				return (
					<div key={i}>
						<input id={props.data.groupCd + props.data.sectionCd + props.data.itemCd}
							   type={'radio'} name={"obj" + props.data.groupCd + props.data.sectionCd + props.data.itemCd}
							   value={item.subCode}
							   checked={value === item.subCode}
							   onChange={handleChange}/>&nbsp;&nbsp;{item.codeNm}&nbsp;&nbsp;&nbsp;
					</div>
				)
			})}
		</div>
	)
}
